import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { keyframes } from "@mui/system";

interface ProgressButtonProps {
  totalSeconds?: number;
  remainingSeconds: number;
  label: string;
  onClick?: () => void;
  isExpired?: boolean;
  formatCountdown?: (seconds: number) => string;
  sx?: object;
}

// Define animation once outside the component
const slideBlink = keyframes`
  0% { left: -150px; }
  100% { left: 100%; }
`;

const ProgressButton: React.FC<ProgressButtonProps> = ({
  totalSeconds,
  remainingSeconds,
  label,
  onClick,
  isExpired = false,
  formatCountdown,
  sx: sxOverride,
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        position: "relative",
        bgcolor: "#000",
        color: "white",
        textTransform: "none",
        fontWeight: 500,
        borderRadius: 1,
        mt: 1.5,
        width: "100%",
        ...sxOverride,
        overflow: "hidden",
        "&:hover": { bgcolor: "#000" },
      }}
    >
      {/* Sliding Blinker Effect */}
      {!isExpired && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            width: "120px",
            background: `linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.3) 25%,
              rgba(255,255,255,0.5) 50%,
              rgba(255,255,255,0.3) 75%,
              transparent
            )`,
            animation: `${slideBlink} 3.5s linear infinite`,
            zIndex: 0,
          }}
        />
      )}

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {label}
        {!isExpired && (
          <Box ml={1}>
            <Typography sx={{ fontSize: 14 }} fontWeight={600}>
              ({formatCountdown?.(remainingSeconds)})
            </Typography>
          </Box>
        )}
      </Box>
    </Button>
  );
};

export default ProgressButton;
